import Vue from 'vue';
import SvgIcon from './SvgIcon';
import Label from './Label';
import Spinner from './Spinner';
import Button from './Button';
import Wrapper from './Wrapper';
import Title from './Title';
import Subtitle from './Subtitle';

Vue.component('SvgIcon', SvgIcon);
Vue.component('Label', Label);
Vue.component('Spinner', Spinner);
Vue.component('Button', Button);
Vue.component('Wrapper', Wrapper);
Vue.component('Title', Title);
Vue.component('Subtitle', Subtitle);
